import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Operation } from 'src/app/_models/operation';
import { Suboperation } from 'src/app/_models/suboperation';
import { MessService } from 'src/app/_services/mess-service.service';
import { OperationsService } from 'src/app/_services/operations.service';

@Component({
  selector: 'app-operations-edit',
  templateUrl: './operations-edit.component.html',
})
export class OperationsEditComponent implements OnInit, OnDestroy {
  currentOperation: Operation;
  updateOperationForm: FormGroup;
  suboperations: FormArray;
  loading = false;

  subscriptions: Subscription[] = [];

  constructor(
    private operationsService: OperationsService,
    private fb: FormBuilder,
    private messService: MessService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.subscriptions.push(
      this.operationsService.updateOperationData.subscribe((operationData) => {
        if (!operationData) {
          this.router.navigate(['./../'], { relativeTo: this.route });
          return;
        }
        this.currentOperation = operationData;

        this.updateOperationForm = this.fb.group({
          label: [this.currentOperation.label, Validators.required],
          name: [this.currentOperation.name, Validators.required],
          coefficient: [
            this.currentOperation?.last_coefficient?.coefficient ?? '',
            Validators.required,
          ],
          year: [new Date().getFullYear()],

          cost: [this.currentOperation.cost],
          suboperations: this.fb.array([]),
        });

        this.suboperations = this.updateOperationForm.get(
          'suboperations'
        ) as FormArray;
        this.currentOperation.suboperations.forEach(
          (suboperation: Suboperation) => {
            this.suboperations.push(
              this.fb.group({
                id: [suboperation.id, Validators.required],
                label: [suboperation.label, Validators.required],
                name: [suboperation.name, Validators.required],
                cost: [suboperation.cost, Validators.required],
              })
            );
          }
        );
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  // * Update operation === //
  onUpdateOperation() {
    this.loading = true;
    let operation = this.updateOperationForm.getRawValue();
    const currentOperationId = this.currentOperation.id;
    this.subscriptions.push(
      this.operationsService
        .updateOperation(operation, currentOperationId)
        .subscribe(
          () => {
            this.messService.add({
              severity: 'success',
              title: 'Uspešno ažuriranje',
              detail: 'Uspešno ste ažurirali operaciju.',
            });
            this.loading = false;
          },
          (error) => {
            const errorObj = error.error.errors;
            const form = this.updateOperationForm;
            const messService = this.messService;
            Object.keys(errorObj).forEach(function (key) {
              const formControl = form.get(key);
              if (formControl) {
                // If error exist set red border to field
                formControl.setErrors({});
              }
              // Push toast error for every field
              messService.addError({
                severity: 'error',
                title: 'Greška',
                detail: errorObj[key],
                sticky: true,
              });
              this.loading = false;
            });
          }
        )
    );
  }

  // * Helpers === //
  getControls() {
    return (<FormArray>this.updateOperationForm.get('suboperations')).controls;
  }

  removeSuboperation(suboperationId: number) {
    this.suboperations.removeAt(suboperationId);
  }

  createSuboperation(): FormGroup {
    return this.fb.group({
      label: ['', Validators.required],
      name: ['', Validators.required],
      cost: [''],
    });
  }

  addSuboperation(): void {
    this.suboperations.push(this.createSuboperation());
  }
}
